import React from 'react';
import {Tooltip, Button} from '@enos/dpl';
import {observer, inject} from 'mobx-react';
import {toJS} from 'mobx';
import moment from 'moment';
import _ from 'lodash';
import localeText from '@locale';
import image from '~/assets/images/no_message_dark.svg';
import uiStore from './store';
import MessageDetailOnMobile from './mobile';
import WebsocketService from '~/services/websocketService';
import MessageBody from '~/components/MessageBody';
import {ALARM_MESSAGE_LENGTH} from '~/utils/constants';
import './index.less';

@inject('portalStore', 'messageStore', 'sessionStore')
@observer
class MessageDetail extends React.Component {
  messageColor = ['rgba(247, 76, 96, 1)', 'rgba(250, 174, 10, 1)', 'rgba(138, 139, 153, 1)'];

  messageBoxShadow = ['0px 0px 5px rgba(247,76,96,0.4)', '0px 0px 5px rgba(250,174,10,0.4)', '0px 0px 5px  rgba(138,139,153,0.4)'];

  mesRef = [];

  handleClose = () => {
    const {messageStore} = this.props;
    messageStore.toggleMessagePoPUp(false);
  };

  toggleSound = () => {
    const {messageStore} = this.props;
    messageStore.toggleSound(!messageStore.disableSound);
    if (messageStore.disableSound) {
      messageStore.setSoundLoop(0);
    }
  };

  showAll = () => {
    const {messageStore} = this.props;
    messageStore.toggleMessagePoPUp(!messageStore.showMessage);
    window.$sdk$.switchPage({
      appId: messageStore.currentApp.linkedAppId,
      menuCode: messageStore.currentApp.linkedMenuCode,
      state: messageStore.currentApp.linkedStates
    });
  };

  toggleAutoPopUp = () => {
    const {messageStore} = this.props;
    messageStore.toggleAutoPopUp(!messageStore.disableDialog);
  };

  selectApp = (app) => {
    const {messageStore} = this.props;
    messageStore.setCurrentApp(app);
    const messageList = document.getElementById('message-list');
    if (messageList) {
      messageList.scrollTop = 0;
    }
  };

  showMessageDetail = (item) => {
    const {messageStore} = this.props;
    messageStore.toggleMessagePoPUp(!messageStore.showMessage);
    window.$sdk$.switchPage({
      appId: item.linkedAppId,
      menuCode: item.linkedMenuCode,
      state: item.linkedStates
    });
  };

  // 加载更多
  loadMore = () => {
    const {messageStore} = this.props;
    messageStore.setLoading(true);
    WebsocketService.send(JSON.stringify({
      appId: messageStore.currentApp.id,
      currentPage: 0
    }));
  }

  renderApps = data => (data || []).map((item) => {
    const {messageStore} = this.props;
    return (
      <div
        {...{[['key'][0]]: item.id}}
        title={item.name}
        className={messageStore.currentApp && messageStore.currentApp.id === item.id ? 'app-name active' : 'app-name'}
        onClick={() => this.selectApp(item)}
      >
        <span className='name'>{item.name}</span>
        <span className='count'>{`(${item.count})`}</span>
      </div>
    );
  });

  renderAppsOnMobile = () => {
    const {messageStore} = this.props;
    const apps = uiStore.limitHeight ? messageStore.apps.slice(0, 4) : messageStore.apps;
    return (
      messageStore.apps.length > 0 && (
        <div className='app-wrap' {...{[['key'][0]]: 'app-wrap'}}>
          <div className={toJS(messageStore.apps).length > 4 ? 'app-list' : 'app-list no-hint'}>{this.renderApps(apps)} </div>
          {toJS(messageStore.apps).length > 4 && this.renderHint()}
        </div>
      )
    );
  };

  renderMessages = data => (data || []).map(item => (
    <div
      {...{[['key'][0]]: item.id}}
      ref={(r) => {
        if (this.props.messageStore.currentApp) {
          this.mesRef[`${this.props.messageStore.currentApp.id}-${item.id}`] = r;
        }
      }}
      className='message'
      onClick={() => this.showMessageDetail(item)}
    >
      <div className='tags'>
        <i className='dpl20_alarm_portal' style={{color: this.messageColor[item.color], textShadow: this.messageBoxShadow[item.color]}} />
        {this.renderTags(item.tags)}
      </div>
      <MessageBody item={item.body} width='322' />
      <div className='detail'>
        <span>{this.renderTime(item.messageTime, item.zoneOffset)}</span>
        <span className='short-line' />
        <span>{item.feature}</span>
      </div>
      {item.actionName !== undefined && (
        <div className='action'>
          <Button type='primary' size='small' className='action-name' onClick={e => this.removeMessage(e, item.id)}>
            {item.actionName}
          </Button>
        </div>
      )}
    </div>
  ));

  removeMessage = (e, id) => {
    const {messageStore} = this.props;
    e.stopPropagation();
    if (messageStore.currentApp) {
      this.mesRef[`${messageStore.currentApp.id}-${id}`].classList.add('remove-current-meaasge');
    }
    setTimeout(() => {
      messageStore.removeMessage(id, messageStore.currentApp.id, this.props.env);
    }, 500);
  };

  renderTags = data => ((data && data.slice(0, 3)) || []).map(item => (
    <span {...{[['key'][0]]: item}} title={item}>
      {item}
    </span>
  ));

  renderTime = (data, zone) => {
    const localTime = moment(data)
      .utc(data)
      .utcOffset(zone)
      .format('YYYY/MM/DD HH:mm');
    return (
      <span>
        <span>{`${localTime}`}</span> <span>({zone})</span>
      </span>
    );
  };

  renderHint = () => {
    const {messageStore} = this.props;
    return (
      <div className='hint' onClick={uiStore.limitWrapHeight}>
        {uiStore.limitHeight ? (
          <span>
            <span>
              {localeText(
                'MESSAGE.TXT_APP_HINT1',
                toJS(messageStore.apps).length - 4,
                messageStore.messagesNumber - _.sumBy(messageStore.apps.slice(0, 4), 'count')
              )}
            </span>
          </span>
        ) : (
          <span>{localeText('MESSAGE.TXT_APP_HINT2')}</span>
        )}

        <span>
          <i className={uiStore.limitHeight ? 'dpl20_caret_down_s' : 'dpl20_caret_up_s'} />
        </span>
      </div>
    );
  };

  renderMessageContent = () => {
    const {messageStore} = this.props;
    return messageStore.apps.length ? (
      <div className='message-content'>
        <div className='left-side'> {this.renderApps(messageStore.apps)}</div>
        <div className='right-side'>
          <div className='message-list' id='message-list'>
            {this.renderMessages(messageStore.currentApp && messageStore.currentApp.messages)}
            {
              // eslint-disable-next-line max-len
              (messageStore.currentApp.messages?.length < ALARM_MESSAGE_LENGTH) && (messageStore.currentApp.messages?.length < messageStore.currentApp?.count) && (
                <div
                  className='load-more'
                  onClick={() => this.loadMore()}
                >
                  <i className={messageStore.loading ? 'dplicon_loading' : 'dplicon_refresh'} />
                  {
                    messageStore.isLoadFailed ? (
                      <span>
                        {localeText('MESSAGE.TXT_LOAD_FAILED')}
                      </span>
                    ) : (
                      <span>
                        {messageStore.loading ? localeText('MESSAGE.TXT_LOADING') : localeText('MESSAGE.TXT_LOAD_MORE')}
                      </span>
                    )
                  }
                </div>
              )
            }
          </div>
          {messageStore.currentApp.linkedAppId
           && (
             <div className='show-all' onClick={this.showAll}>
               {localeText('MESSAGE.TXT_SHOW_ALL')}
             </div>
           ) }
        </div>
      </div>
    ) : (
      <div className='no-message'>
        <img src={image} alt='404' />
        <span className='no-message-hint'>{localeText('MESSAGE.TXT_NO_MESSAGE')}</span>
      </div>
    );
  };

  render() {
    const {messageStore, sessionStore} = this.props;
    return sessionStore.isMobile ? (
      <MessageDetailOnMobile
        renderAppsOnMobile={this.renderAppsOnMobile}
        renderMessages={this.renderMessages}
        toggleMessagePoPUp={messageStore.toggleMessagePoPUp}
        messageStore={messageStore}
      />
    ) : (
      <div className={messageStore.showMessage ? 'message-detail' : 'message-detail hidden'}>
        <div className='toolbar'>
          <span className='name'>
            {localeText('MESSAGE.TITLE_NAME')}({messageStore.messagesNumber})
          </span>
          <span className='icon'>
            <Tooltip
              overlayClassName='message-setting'
              title={messageStore.disableSound ? localeText('MESSAGE.TXT_TO_SOUND') : localeText('MESSAGE.TXT_TO_MUTE')}
            >
              <i className={messageStore.disableSound ? 'dpl20_mute' : 'dpl20_sound'} onClick={this.toggleSound} />
            </Tooltip>
            <Tooltip
              overlayClassName='message-setting'
              title={messageStore.disableDialog ? localeText('MESSAGE.TXT_DIALOG') : localeText('MESSAGE.TXT_DISABLE_DIALOG')}
            >
              <i className={messageStore.disableDialog ? 'dpl20_no_alarm_box' : 'dpl20_alarm_box'} onClick={this.toggleAutoPopUp} />
            </Tooltip>
            <Tooltip overlayClassName='message-setting' title={localeText('MESSAGE.TXT_CLOSE_DIALOG')}>
              <i className='dpl20_wrong' onClick={this.handleClose} />
            </Tooltip>
          </span>
        </div>
        {this.renderMessageContent()}
      </div>
    );
  }
}

export default MessageDetail;
